import * as React from 'react';
import './ReportingTagCategoryPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { IReportingTagCategoryReduxFormState, initialReportingTagCategoryState } from "../../../reducers/reactReduxForms/reportingTagCategory";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as ReportingTagCategoryActions from '../../../actions/reportingTagCategories';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { QALookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';

interface IReportingTagCategoryPageParams {
    reportingTagCategoryId: number;
}

interface IReportingTagCategoryPageProps {

    form: Dtos.ReportingTagCategory & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: IReportingTagCategoryReduxFormState;

    location: Location;
    reportingTagCategoryId: number;
    match: match<IReportingTagCategoryPageParams>;
    history: History;

    // From state
    reportingTagCategory: Dtos.ReportingTagCategory;
    lookups: Dtos.Lookup[];

    loadingReportingTagCategory: boolean;
    loadReportingTagCategorySuccess: boolean;
    loadReportingTagCategoryFailure: boolean;

    savingReportingTagCategory: boolean;
    saveReportingTagCategorySuccess: boolean;
    saveReportingTagCategoryFailure: boolean;

    creatingReportingTagCategory: boolean;
    createReportingTagCategorySuccess: boolean;
    createReportingTagCategoryFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface IReportingTagCategoryPageActions {
    clearReportingTagCategory: ReportingTagCategoryActions.IReportingTagCategoryClearActionCreator;
    loadReportingTagCategory: ReportingTagCategoryActions.IReportingTagCategoryLoadByIdActionCreator;

    saveReportingTagCategory: ReportingTagCategoryActions.IReportingTagCategorySaveActionCreator;
    createReportingTagCategory: ReportingTagCategoryActions.IReportingTagCategoryCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type ReportingTagCategoryPageProps = IReportingTagCategoryPageProps & IReportingTagCategoryPageActions;

const reduxFormName: string = "reduxForms.reportingTagCategory";

class ReportingTagCategoryPage extends React.PureComponent<ReportingTagCategoryPageProps, any> {

    constructor(props: ReportingTagCategoryPageProps) {
        super(props);

        this.clearReportingTagCategory = this.clearReportingTagCategory.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadReportingTagCategory,
            reportingTagCategoryId,
            createReportingTagCategory
        } = this.props;

        if (reportingTagCategoryId) {
            loadReportingTagCategory(reportingTagCategoryId);
        } else if (!reportingTagCategoryId) {
            createReportingTagCategory();
        }
    }

    componentWillReceiveProps(nextProps: ReportingTagCategoryPageProps) {
    }

    componentDidUpdate(prevProps: ReportingTagCategoryPageProps, prevState) {
        const {
            reportingTagCategoryId,
            reportingTagCategory,
            form,
            navigate,
            loadReportingTagCategory,
            loadingReportingTagCategory,
            loadReportingTagCategorySuccess,
            createReportingTagCategory,
            creatingReportingTagCategory,
            createReportingTagCategorySuccess,
            savingReportingTagCategory,
            saveReportingTagCategorySuccess,
            validationFailures
        } = this.props;

        if (reportingTagCategoryId && prevProps.reportingTagCategoryId != reportingTagCategoryId) {
            loadReportingTagCategory(reportingTagCategoryId);
        }
        else if (!reportingTagCategoryId && prevProps.reportingTagCategoryId) {
            createReportingTagCategory();
        }

        if (!loadingReportingTagCategory && prevProps.loadingReportingTagCategory) {
            if (loadReportingTagCategorySuccess) {
                this.loadForm();
            }
        }

        if (!savingReportingTagCategory && prevProps.savingReportingTagCategory) {
            if (saveReportingTagCategorySuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {
                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);
                }
                if (form.saveAndReturn) {
                    navigate("/settings/qa/reportingTagCategories")
                } else if (!form.saveAndReturn && reportingTagCategoryId && reportingTagCategoryId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !reportingTagCategoryId && reportingTagCategory && reportingTagCategory.id > 0) {
                    navigate("/settings/qa/reportingTagCategories/" + reportingTagCategory.id);
                }
            }
            else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingReportingTagCategory && prevProps.creatingReportingTagCategory) {
            if (createReportingTagCategorySuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(nextProps: ReportingTagCategoryPageProps) {
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearReportingTagCategory();
        loadForm(reduxFormName, initialReportingTagCategoryState);
        resetForm(reduxFormName);
    }

    clearReportingTagCategory() {
        this.props.clearReportingTagCategory();
    }

    showReportingTagCategory(): boolean {
        const {
            loadingReportingTagCategory,
            loadReportingTagCategorySuccess
        } = this.props

        if (!loadingReportingTagCategory && loadReportingTagCategorySuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingReportingTagCategory
        } = this.props;

        return <QALookupsLayout loading={loadingReportingTagCategory} permission={Dtos.Permission.ReportingTagCategoriesView}>
            {this.renderContent()}
        </QALookupsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingReportingTagCategory,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.ReportingTagCategoriesUpdate, Dtos.Permission.ReportingTagCategoriesCreate);
        const formDisabled: boolean = !hasPermission || savingReportingTagCategory || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };

        return <div>
            <h1>Reporting Tag Category</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "reportingTagCategory", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.ReportingTagCategory) {
        const {
            saveReportingTagCategory
        } = this.props;

        if (data) {
            let changes: Dtos.ReportingTagCategory = {} as Dtos.ReportingTagCategory;
            saveReportingTagCategory(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.ReportingTagCategory) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/qa/reportingTagCategories");
    }

    loadForm() {
        const {
            loadForm,
            reportingTagCategory,
        } = this.props

        let extraData: Dtos.ReportingTagCategory = {} as Dtos.ReportingTagCategory;

        loadForm(reduxFormName, Object.assign({ ...reportingTagCategory }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: ReportingTagCategoryPageProps): IReportingTagCategoryPageProps => {

    let reportingTagCategory: Dtos.ReportingTagCategory | undefined = !(state.reportingTagCategories.formData instanceof Array) ? state.reportingTagCategories.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        reportingTagCategoryId: ownProps.match && ownProps.match.params.reportingTagCategoryId && ownProps.match.params.reportingTagCategoryId.toString() != "create" ? ownProps.match.params.reportingTagCategoryId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        reportingTagCategory: reportingTagCategory!,

        loadingReportingTagCategory: state.reportingTagCategories.loadState && state.reportingTagCategories.loadState.status == RequestState.Pending,
        loadReportingTagCategorySuccess: state.reportingTagCategories.loadState && state.reportingTagCategories.loadState.status == RequestState.Success,
        loadReportingTagCategoryFailure: state.reportingTagCategories.loadState && state.reportingTagCategories.loadState.status == RequestState.Failure,

        savingReportingTagCategory: state.reportingTagCategories.saveState && state.reportingTagCategories.saveState.status == RequestState.Pending,
        saveReportingTagCategorySuccess: state.reportingTagCategories.saveState && state.reportingTagCategories.saveState.status == RequestState.Success,
        saveReportingTagCategoryFailure: state.reportingTagCategories.saveState && state.reportingTagCategories.saveState.status == RequestState.Failure,

        creatingReportingTagCategory: state.reportingTagCategories.createState && state.reportingTagCategories.createState.status == RequestState.Pending,
        createReportingTagCategorySuccess: state.reportingTagCategories.createState && state.reportingTagCategories.createState.status == RequestState.Success,
        createReportingTagCategoryFailure: state.reportingTagCategories.createState && state.reportingTagCategories.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: [],

        form: state.reduxForms.reportingTagCategory,
        formState: state.reportingTagCategories.formState,
        formProperties: state.reportingTagCategories.formProperties,

        reduxFormState: state.reduxForms.formState.reportingTagCategory,
        validationFailures: reportingTagCategory ?
            state.reportingTagCategories.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): IReportingTagCategoryPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadReportingTagCategory: bindActionCreators(ReportingTagCategoryActions.LoadReportingTagCategoryById, dispatch),
        clearReportingTagCategory: bindActionCreators(ReportingTagCategoryActions.Clear, dispatch),

        saveReportingTagCategory: bindActionCreators(ReportingTagCategoryActions.SaveReportingTagCategory, dispatch),
        createReportingTagCategory: bindActionCreators(ReportingTagCategoryActions.CreateReportingTagCategory, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(ReportingTagCategoryPage);
